import api from "@/lib/api";

// Company trip-code rules, loaded once and applied to every trip on the fly.
let RULES = {};
let loaded = null;
export const FLAG_LABELS = { aba: "ABA", wheelchair: "Wheelchair van", alone: "Ride alone", shared: "Shared OK", monitor: "Monitor seat", escort: "Escort seat" };

const index = (codes) => Object.fromEntries((codes || []).map((c) => [String(c.code).toUpperCase(), c]));
export const setTripCodes = (codes) => { RULES = index(codes); };
export const loadTripCodes = (force = false) => {
  if (!loaded || force) loaded = api.get("/trip-codes").then((r) => { setTripCodes(r.data.codes); return r.data; }).catch(() => ({ codes: [] }));
  return loaded;
};

// Codes can sit in the trip type, mobility notes or instructions, e.g. "CN,ES(1),WC" or "ABA-1ON1".
export const codesOf = (t) => {
  if (!t) return [];
  const raw = [t.trip_type, t.mobility_notes, t.special_instructions, t.notes, ...(t.mobility_codes || [])].filter(Boolean).join(" ");
  const tokens = raw.toUpperCase().split(/[\s,;|/]+/).map((x) => x.replace(/\(\d+\)$/, "").replace(/[^A-Z0-9-]/g, "")).filter(Boolean);
  return [...new Set(tokens)].filter((x) => RULES[x]).map((x) => RULES[x]);
};

// Code-looking tokens (ALL-CAPS, no spaces) in the trip type / mobility notes that aren't in the company list.
export const unknownCodes = (trips) => {
  const out = {};
  (trips || []).filter((t) => !/cancel/i.test(t.status || "")).forEach((t) => {
    const segs = [t.trip_type, t.mobility_notes].filter(Boolean).join(",").split(/[,;|/\s]+/).map((s) => s.trim());
    new Set(segs.filter((s) => /^[A-Z0-9][A-Z0-9()-]{1,19}$/.test(s)).map((s) => s.replace(/\(\d+\)$/, "")))
      .forEach((c) => { if (!RULES[c]) out[c] = (out[c] || 0) + 1; });
  });
  return Object.entries(out).sort((a, b) => b[1] - a[1]);
};

export const tripFlags = (t) => {
  const f = { aba: false, wheelchair: !!t?.wheelchair, alone: false, shared: false, monitor: false, escort: !!t?.escort };
  codesOf(t).forEach((c) => Object.keys(f).forEach((k) => { if (c[k]) f[k] = true; }));
  return f;
};
